// TODO: migrate to ./store.js
export default {
	store_updateCommitmentError: "An error occurred while updating an action item: {message}",
	store_loadCommitmentError: "An error occurred while loading action item(s): {message}",
	store_loadMeetingError: "An error occurred while loading a meeting: {message}",
	store_loadPageOfPastMeetingsError: "An error occurred while loading a page of past meetings: {error}",
};



// WEBPACK FOOTER //
// ./src/lang/en/commitmentsStore.js